import styled from 'styled-components';

import {
  Button,
  InlineInput,
} from 'web-components';

import {
  Flex,
  icons,
  SVG,
} from 'web-styled';

import {
  Link,
} from 'react-router';

export const Header = styled(Flex).attrs({
  spacing: 10,
  align: 'center',
  justify: 'space-between',
})`
  color: #fff;
  padding: 20px;
  margin: -1px -1px 0 -1px;
  width: calc(100% + 2px);
  background: ${props => props.theme.colors.baseBanner};
  border-radius: 6px 6px 0 0;
  position: relative;

  @media print {
    width: auto;
    margin: 0;
    background: none;
    padding: 0;
  }
`;

export const Title = styled.div`
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  padding: 0;

  @media print {
    color: #000;
    font-size: 25px;
    font-weight: 900;
    padding-left: 0;
  }

`;

export const TitleInput = styled(InlineInput).attrs({
  placeholderColor: '#efefef',
})`
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  padding: 0;
  height: auto;
  border: none !important;
  box-shadow: none !important;
  background: none !important;

  @media print {
    color: #000;
    padding-left: 0;
    font-size: 25px;
  }
`;


export const BookmarkIcon = styled.div`
  position: absolute;
  top: -22px;
  cursor: pointer;
  width: 14px;
  height: 29px;

  @media print {
    display: none;
  };
`;

export const Bookmark = styled(SVG.Bookmark).attrs(
  props => ({
    fill: props.theme.colors.bookmark,
  }),
)``;

export const BookmarkActive = styled(SVG.BookmarkActive).attrs(
  props => ({
    fill: props.theme.colors.bookmarkActive,
  }),
)``;

export const Actions = styled(Button)`
  border: none;
  margin-top: -5px;
  background: url(${icons.contextMenu}) no-repeat;
  background-size: contain;
  background-color: transparent;
  height: 30px;
  width: 30px;

  &:hover {
    opacity: 0.7;
  }
`;

export const LinkAsButton = styled(Link)`
  align-items: baseline;
  align-self: flex-start;
  background-color: transparent;
  border-radius: 50px;
  border-width: 1px;
  border-color: #fff;
  filter: none;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: flex;
  font-size: 12px;
  font-style: normal;
  margin: 0;
  max-width: 100%;
  outline: none !important;
  padding: 7px 12px;
  pointer-events: auto;
  text-align: center;
  justify-content: center;
  text-decoration: none;
  transition: background 0.1s ease-out,box-shadow 0.15s cubic-bezier(0.47,0.03,0.49,1.38);
  transition-duration: 0.1s,0.15s;
  vertical-align: middle;
  white-space: nowrap;
  width: auto;
  height: auto;
  box-shadow: none;
  user-select: none;
  appearance: none;
`;
